
const baseHeaders = {
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
    'Content-Security-Policy': "default-src 'self'",
    'X-Frame-Options': 'DENY',
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'strict-origin-when-cross-origin',
    'Permissions-Policy': 'camera=(), microphone=(), geolocation=()',
};

const getRequest = (url) => {
    return handleResponse(
        fetch(url, {
            method: 'GET',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
        })
    );
}

const postRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const postRequestText = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                ...baseHeaders,
                'Content-Type': 'text/plain',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: data
        })
    );
}

const postFormRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                // FormData için 'Content-Type' tarayıcı tarafından otomatik ayarlanmalıdır.
                // Bu yüzden sadece baseHeaders'ı 'Content-Type' olmadan ekliyoruz.
                ...baseHeaders,
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: data
        })
    );
}

const putRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'PUT',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const deleteRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'DELETE',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const handleResponse = (promise) => {
    return promise.then(response => {
        if (!response.ok) {
            if (response.status === 401) {
                // Yetkisiz istek durumunda kullanıcıyı giriş sayfasına yönlendir.
                window.location.href = process.env.PUBLIC_URL;
                return { success: false };
            }
            return response.text().then(text => {
                let payload = null;
                try {
                    payload = text ? JSON.parse(text) : null;
                } catch (_) {
                    payload = null;
                }

                const error = new Error(payload?.message || text || response.statusText);
                error.status = response.status;
                error.response = payload;
                throw error;
            });
        }
        // text/plain gibi farklı response türlerini de handle etmek gerekebilir.
        // Şimdilik sadece json varsayılıyor.
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json();
        } else {
            return response.text();
        }
    });
}

const getFileRequest = (url, method, data) => {
    return fetch(url, {
        method: method,
        headers: {
            ...baseHeaders,
            'Content-Type': 'application/octet-stream',
            'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

        },
        body: JSON.stringify(data)
    });
}

const getFileRequestData = (url, method, data) => {
    return fetch(url, {
        method: method,
        headers: {
            ...baseHeaders,
            'Content-Type': 'application/json',
            'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

        },
        body: JSON.stringify(data)
    });
}

const downloadFile = async (url) => {
    const resp = await fetch(url, {
        method: "GET",
        headers: {
            ...baseHeaders,
            // Content-Type koyma zorunlu değil; hatta GET'te koymasan daha iyi
            "ozt": localStorage.getItem(process.env.REACT_APP_LS_TOKEN),
        },
    });

    if (!resp.ok) {
        if (resp.status === 401) {
            window.location.href = process.env.PUBLIC_URL;
            return { success: false };
        }
        const txt = await resp.text().catch(() => "");
        throw new Error(txt || resp.statusText);
    }

    // filename yakala (backend File(...) döndüğü için çoğu zaman gelir)
    let fileName = null;
    const cd = resp.headers.get("content-disposition");
    if (cd) {
        // filename*=UTF-8''... veya filename="..."
        const m1 = cd.match(/filename\*\=UTF-8''([^;]+)/i);
        const m2 = cd.match(/filename\=\"?([^\";]+)\"?/i);
        fileName = decodeURIComponent((m1 && m1[1]) || (m2 && m2[1]) || "").trim();
    }

    const blob = await resp.blob();
    return { success: true, blob, fileName };
};


export const requestTool = {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    postFormRequest,
    postRequestText,
    getFileRequest,
    getFileRequestData,
    downloadFile
}

export default requestTool;
